module.exports = __webpack_public_path__ + "static/media/berth.8ffff658.svg";